/**
 * Base API URL selection for the application.
 *
 * Precedence:
 * 1. `NEXT_PUBLIC_API_URL_PROD` (explicit override)
 * 2. `NEXT_PUBLIC_API_URL_PROD` / `NEXT_PUBLIC_API_URL_DEV` depending on variant
 * 3. Defaults: production -> `https://backend.cashlessai.cloud`, dev -> `http://localhost:8000/api`
 *
 * Control which variant to use with `NEXT_PUBLIC_BACKEND_VARIANT` = 'prod' | 'dev'.
 * If `NEXT_PUBLIC_BACKEND_VARIANT` is not set, we infer it from `NODE_ENV`.
 */

const prodEnv = process.env.NEXT_PUBLIC_API_URL_PROD;
const devEnv = process.env.NEXT_PUBLIC_API_URL_DEV;
const variantEnv = process.env.NEXT_PUBLIC_BACKEND_VARIANT; // 'prod' | 'dev'

function stripTrailingSlash(s: string) {
  return s.replace(/\s+$/g, "").replace(/\/+$/, "");
}

function deriveWsUrl(httpUrl: string) {
  if (!httpUrl) return "";
  if (httpUrl.startsWith("https://")) return httpUrl.replace(/^https:/, "wss:");
  if (httpUrl.startsWith("http://")) return httpUrl.replace(/^http:/, "ws:");
  return "";
}

let chosenRaw: string = "";
const defaultVariant = process.env.NODE_ENV === "production" ? "prod" : "dev";
const variant = (variantEnv ?? defaultVariant).toLowerCase(); // 'prod' | 'dev'

if (variant === "prod") {
  chosenRaw = prodEnv ?? "";
} else if (variant === "dev") {
  chosenRaw = devEnv ?? "";
}

if (!chosenRaw) {
  if (typeof window === "undefined") {
    // server/build
    // eslint-disable-next-line no-console
    console.warn(
      "NEXT_PUBLIC_API_URL_PROD (or NEXT_PUBLIC_API_URL_PROD/DEV) not set. API_URL will be empty.",
    );
  } else {
    // browser
    // eslint-disable-next-line no-console
    console.error(
      "NEXT_PUBLIC_API_URL_PROD (or NEXT_PUBLIC_API_URL_PROD/DEV) not set. Please set it in your environment.",
    );
  }
}

export const API_URL = stripTrailingSlash(chosenRaw);
export const WS_API_URL = deriveWsUrl(API_URL);
